import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'swb-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

  ngOnInit() {
  }

}
